import {getAllMessage,updateMessStatus} from '../../../service/service'
export default {
    name:'notic',
    data: function() {
      return {
        total: 0,
        patientName:'',
        dateOfSurgery: '',
        keywordSearch: '',
        columns4: [
          {
            title: this.$t('Software'),
            key: 'software'
          },{
            title: this.$t('Expiration Date'),
            slot: 'expirationdate'
          },{
            title: ' ',
            width: 100,
            slot: 'action'
          }
        ],
        data4: [
          {
            software: 'ImmersiveView',
            expirationdate: '03/16/2020'
          },{
            software: 'IVSP',
            expirationdate: '03/16/2020'
          },{
            software: 'ImmersiveTouch',
            expirationdate: '03/16/2020'
          },{
            software: 'ImmersiveTouch',
            expirationdate: '03/16/2020'
          }
        ],
        columns1: [
            {
                title: this.$t('name'),
                width: 400,
                slot: 'messtitle'
            },{
                title: this.$t('email'),
                slot: 'messdesc'
            },{
                title: this.$t('phone number'),
                slot: 'messtime',
                width: 250
            },{
                title: this.$t('admin'),
                slot: 'admin'
            }
        ],
        data1: [],
        modal: false,
        modal1: false,
        modal2: false,
        modal3: false,
        modal4: false,
        modal5: false,
        modal6: false,
        modal7: false,
        modal8: false,
        modal9: false,
        modal10: false,
        txtTitle:'',
        txtComment: 'You have reset your account password successfully.',
        formItem: {
            physician: '',
            specialty: '',
            patientname: '',
            hospital: '',
            dateofsurgery: '',
            priority: false
        },
        note:'',
        ruleInline: {
            patientname: [
                { required: true, message: this.$t('Please fill in the patient name'), trigger: 'blur' }
            ],
            hospital: [
                { required: true, message: this.$t('Please select the hospital'), trigger: 'change' }
            ],
            priority:[
                { required: true, message: this.$t('Please select at priority'), trigger: 'change', type: 'boolean' }
            ]
        },
        modalNext: false,
        fileList: [],
        showTable: '',
        modalName:'',
        modalPhone:'',
        oldEmailLogin:'',
        newEmailLogin:'',
        software:'',
        expirationDate:'',
        newName:'',
        newEmail:'',
        role:'',
        surgery:'',
        pagesize:20,
        pageTo: 1,
        page: 1,
        row:{},
        myName:'Mira Liu',
        myCompany:'Orthopedics',
        hospitalInputList:[
          {hospitalName:''}
        ],
        num:0,
        time: '',
        showInfo: true
      }
    },
    methods: {
        changePage(e){
            // console.log(e)
            this.page = e
            this.pageTo = e
            this.reloadView()
        },
        formatMess(desc){
            let de = desc;
            return de.replace(/<[^>]+>/g,'');
        },
        goPage(){
            if(this.pageTo){
                let maxPage = Math.ceil(parseInt(this.total) / parseInt(this.pagesize))
                if(parseInt(this.pageTo) > maxPage){
                    this.page = maxPage
                }else{
                    this.page = parseInt(this.pageTo)
                }
                this.pageTo = this.page
                this.reloadView()
            }else{
                this.pageTo = this.page
            }
        },
        addComment(row){
            console.log(row)
            console.log(2)
            if(this.showInfo){
                this.modal = true
                this.txtTitle = row.messtitle+'<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>'+row.messtime
                this.txtComment = row.messdesc
                this.time = row.messtime
                let p = {
                    messId: row.messid,
                    status: 'Inbox|Read'
                }
                if (row.status != 'Inbox|Archieved'){

                    updateMessStatus(p).then(res => {
                        if (res.code === '0') {
                            // this.$Message.success('success')
                            this.reloadView()
                        } else {
                            this.$Message.warning('fail')
                        }
                    })
                }
            }
        },
        addComment2(row){
            console.log(row)
            this.modal = true
            this.txtComment = row.messdesc
        },
        addComment3(row){
            console.log(row)
            this.modal = true
            this.txtComment = row.messdesc
        },
      delHospital(index){
        this.hospitalInputList.splice(index,1)
      },
      addHospital(){
        let obj={
          hospitalName:''
        }
        this.hospitalInputList.push(obj)
        // let arr = hospitalInputList
        // arr.push(obj)
        // this.hospitalInputList = arr
      },
        changePageSize(size){
            this.page = 1
            this.pageTo = 1
            this.pagesize = size
            this.reloadView()
        },
      sel(row,e){
        console.log(row)
        this.row = row
        console.log(e)
        if(e === 'edit'){
          if(this.showTable === 'sales-representative'){
            this.modal1 = true
          }else{
            this.modal8 = true
          }
        }else if(e === 'change'){
          this.modal2 = true
        }else if(e === 'manage'){
          this.modal4 = true
        }else{
          this.modal9 = true
        }
      },
      inviteUser(){
        if(this.showTable === 'sales-representative'){
          this.modal7 = true
        }else{
          this.modal6 = true
        }
      },
      ok10(){
        this.modal10 = false
      },
      ok9(){
        this.modal9 = false
      },
      cancel9(){
        this.modal9 = false
      },
      ok8(){
        this.modal8 = false
      },
      cancel8(){
        this.modal8 = false
      },
      ok7(){
        this.modal10 = true
        this.modal7 = false
      },
      cancel7(){
        this.modal7 = false
      },
      ok6(){
        this.modal10 = true
        this.modal6 = false
      },
      cancel6(){
        this.modal6 = false
      },
      dateChange(e){
        this.expirationDate = e
          var that = this;
          if (this.searchMark) {
              clearTimeout(this.timeoutId);
              this.timeoutId = setTimeout(function () {
                  that.page = 1;
                  that.reloadView();
              }, 1000);
          } else {
              this.timeoutId = setTimeout(function () {
                  that.page = 1;
                  that.reloadView();
              }, 1000);
              this.searchMark = true;
          }
      },
      addLicenses(){
        this.modal5 = true
      },
      ok5(){
        this.modal5 = false
      },
      cancel5(){
        this.modal5 = false
      },
      ok4(){
        this.modal4 = false
      },
      cancel4(){
        this.modal4 = false
      },
      ok3(){
        this.modal3 = false
      },
      ok2(){
        this.modal3 = true
        this.modal2 = false
      },
      cancel2(){
        this.modal2 = false
      },
      ok1(){
        this.modal3 = true
        this.modal1 = false
      },
      cancel1(){
        this.modal1 = false
      },
        fileAdded(file){
            console.log(file,1)
        },
        delFile(i){
            this.fileList.splice(i,1)
        },
        handleUpload(file){
            console.log(file)
            let arr = this.fileList;
            arr.push(file)
            this.fileList = arr

            return false;
        },
        back(){
            this.modalNext = false
        },
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$Message.success('Success!');
                    this.modalNext = true
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        ok(){
            this.modal = false
            this.modalNext = false
            this.formItem.physician = ''
            this.formItem.specialty = ''
            this.formItem.patientname = ''
            this.formItem.hospital = ''
            this.formItem.dateofsurgery = ''
            this.formItem.priority = false
        },
        cancel () {
            this.modal = false
            this.formItem.physician = ''
            this.formItem.specialty = ''
            this.formItem.patientname = ''
            this.formItem.hospital = ''
            this.formItem.dateofsurgery = ''
            this.formItem.priority = false
        },
      addCase(){
        this.modal = true
      },
      download(row,index){
        console.log(row)
        console.log(index)
      },
      showDate(){
          var that = this;
          if (this.searchMark) {
              clearTimeout(this.timeoutId);
              this.timeoutId = setTimeout(function () {
                  that.page = 1;
                  that.reloadView();
              }, 1000);
          } else {
              this.timeoutId = setTimeout(function () {
                  that.page = 1;
                  that.reloadView();
              }, 1000);
              this.searchMark = true;
          }
      },
      navClick(type){
        sessionStorage.setItem('showTable',type)
          this.showTable = type
          this.pageTo = 1
          this.page = 1
          this.reloadView()
      },
      reloadView(){
        let p = {
            page: this.page,
            limit: this.pagesize,
            time: this.expirationDate,
            keyword: this.keywordSearch,
            status: this.showTable,
            userId: this.token
        }
        getAllMessage(p).then(res=>{
            console.log(res)
            this.$Spin.hide();
            if(res.code === '0'){
                let data = JSON.parse(res.data)
                console.log(data)
                console.log(this.showTable)
                this.data1 = data.list
                // if(this.showTable === 'Unread'){
                //     this.data1 = data.list
                //     console.log(1)
                // }else if(this.showTable === 'Inbox'){
                //     this.data3 = data.list
                //     console.log(3)
                // }else{
                //     this.data2 = data.list
                //     console.log(2)
                // }
                if(this.showTable === 'Inbox|Unread'){
                    this.num = data.total
                }
                this.total = data.total
                this.showInfo = true
            }
        })
      },
        goArchive(row){
            this.showInfo = false
            if(!this.showInfo){
                updateMessStatus({
                    messId: row.messid,
                    status: 'Inbox|Archieved'
                }).then(res=>{
                    if(res.code === '0'){
                        this.$Message.success('success')
                        this.reloadView()
                    }else{
                        this.$Message.warning('fail')
                    }
                })
            }
        },
        goArchive2(row){
            this.showInfo = false
            if(!this.showInfo){
                let p = {
                    messId: row.messid,
                    status: 'Inbox|Read'
                }
                updateMessStatus(p).then(res=>{
                    if(res.code === '0'){
                        this.$Message.success('success')
                        this.reloadView()
                    }else{
                        this.$Message.warning('fail')
                    }
                })
            }
        }
    },
    destroyed(){
        sessionStorage.removeItem('showTable')
    },
    created(){

    },
    mounted(){
        this.showTable = sessionStorage.getItem('showTable') || 'Inbox|Unread'
        this.token = localStorage.getItem('token') || sessionStorage.getItem('token')
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'demo-spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            color:'#f48221',
                            size: 18
                        }
                    }),
                    h('div',{
                        style: {
                            color: '#f48221'
                        },
                    } ,'Loading')
                ])
            }
        });
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function(){
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
        }
        this.reloadView()
        getAllMessage({
            page: this.page,
            limit: this.pagesize,
            time: this.expirationDate,
            keyword: this.keywordSearch,
            status: 'Inbox|Unread',
            userId: this.token
        }).then(res=>{
            console.log(res)
            if(res.code === '0'){
                let data = JSON.parse(res.data)
                this.num = data.total
            }
        })
    }
  }
